import { ReactNode } from 'react';
import { TFunction } from 'i18next';

import { IDefaultPaymentMethod } from '@mopla/data-models';
import {
	AmazonPayIcon,
	CreditCardIcon,
	KlarnaIcon,
	PayByBankIcon,
	PaypalIcon,
	RevolutPayIcon,
	SepaIcon,
} from '@mopla/ui';

interface IPaymentMethodDisplayInfo {
	title: string;
	subtitle: string;
	icon: ReactNode;
}

const paymentMethodIcons: Record<string, ReactNode> = {
	card: <CreditCardIcon />,
	sepa_debit: <SepaIcon />,
	paypal: <PaypalIcon />,
	revolut_pay: <RevolutPayIcon />,
	amazon_pay: <AmazonPayIcon />,
	klarna: <KlarnaIcon />,
	pay_by_bank: <PayByBankIcon />,
};

export const getPaymentMethodDisplayInfo = (
	paymentMethod: IDefaultPaymentMethod,
	t: TFunction
): IPaymentMethodDisplayInfo => {
	const type = paymentMethod.type;
	const icon = paymentMethodIcons[type] ?? <CreditCardIcon />;
	const title = t(`editPaymentMethod:${type}`, type);

	let subtitle = '';

	if (type === 'card' && paymentMethod.card) {
		subtitle = `**** ${paymentMethod.card.last4}`;
	} else if (type === 'sepa_debit' && paymentMethod.sepa_debit) {
		subtitle = `**** ${paymentMethod.sepa_debit.last4}`;
	} else if (type === 'paypal' && paymentMethod.paypal) {
		subtitle = paymentMethod.paypal.payer_email;
	}

	return { title, subtitle, icon };
};
